<div class="tab-inner-content">
  <h2>Vendor Balance Summary</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <table>
    <thead>
      <tr>
        <th>Vendor Name</th>
        <th>Total Amount (In AED)</th>
        <th>Pending Amount (In AED)</th>
      </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of vendorBalanceSummaryReport">
          <td>{{ item?.name }}</td>
          <td>{{ item.totalAmount | number : "1.2-2" }}</td>
          <td>{{ item.pendingAmount | number : "1.2-2" }}</td>
        </tr>
        <tr *ngIf="vendorBalanceSummaryReport?.length === 0">
          <td colspan="3" class="no-data">
            No data available
          </td>
        </tr>
    </tbody>
  </table>
</div>
